import Route from '@ember/routing/route';

import type MetricLibrarySourceController from 'webapp/controllers/metric-library/source';

export default class MetricLibrarySourceIndexRoute extends Route {
	override beforeModel(): void {
		(this.controllerFor('metric-library.source') as MetricLibrarySourceController).set(
			'source',
			null,
		);
	}
}
